/* Work Order Insights - thin API map over the portal HttpClient (sets the /api base URL,
 * attaches the Bearer token, handles 401 -> logout). Mirrors the .NET
 * WorkOrderInsightsController routes (api/work-order-insights/*). Separate report from
 * Manufacturing Insights (its own 'work-order-insights' report-access key) but REUSES the
 * existing 'Manufacturing' role for access. */
import httpClient from "@/assets/js/HttpClient";

const B = "/work-order-insights";
const get = (path) => httpClient.get(B + path).then((r) => r.data);

export default {
  health: () => get("/health"),
  freshness: () => get("/freshness"),
  provenance: () => get("/provenance"),
  kpis: () => get("/kpis"),
  overview: () => get("/overview"),

  throughput: () => get("/throughput"),
  throughputList: (year, month, kind) => get(`/throughput/list/${year}/${month}?kind=${encodeURIComponent(kind)}`),
  aging: () => get("/aging"),
  agingList: (bucket, key) => get(`/aging/list/${encodeURIComponent(bucket)}${key != null ? `?key=${encodeURIComponent(key)}` : ""}`),
  cost: () => get("/cost"),
  costTop: () => get("/cost/top"),
  costList: (year, month) => get(`/cost/list/${year}/${month}`),
  workcenter: () => get("/workcenter"),
  workcenterOps: (resourceId) => get(`/workcenter/${encodeURIComponent(resourceId)}`),
  laborEfficiency: () => get("/labor-efficiency"),
  material: () => get("/material"),
  dependencies: () => get("/dependencies"),
  dependencyTree: (baseId) => get(`/dependencies/${encodeURIComponent(baseId)}`),
  materialAvailability: () => get("/material-availability"),
  materialAvailabilityUnit: (baseId) => get(`/material-availability/${encodeURIComponent(baseId)}`),
  planned: () => get("/planned"),
  plannedList: (bucket) => get(`/planned/list/${encodeURIComponent(bucket)}`),
  plannedByResource: () => get("/planned/by-resource"),

  // Unit Orders (historical closed unit/customer WOs) — list + summary stats + per-unit drills
  unitHistory: () => get("/unit-history"),
  unitHistoryStats: () => get("/unit-history/stats"),
  unitHistoryOps: (wo) => get(`/unit-history/ops/${encodeURIComponent(wo)}`),
  unitHistoryParts: (wo) => get(`/unit-history/parts/${encodeURIComponent(wo)}`),

  // report-access gate (reuses the existing portal endpoint / 'work-order-insights' key)
  accessMine: () => httpClient.get("/report/access/mine").then((r) => r.data),
};
